module.exports = __webpack_public_path__ + "img/credits.6bc15e00.png";